import { useState } from "react";
import { useConfig } from "../../../context/ConfigContext";

export default function PrintAllTickets() {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const { config } = useConfig();
  const apiBase = config.REACT_APP_RAFFLE_BASE_URL;
  const apiKey = config.REACT_APP_ADMIN_API_KEY;

  async function printAll() {
    setLoading(true);
    setMsg("");

    const res = await fetch(`${apiBase}/print-all`, {
      method: "POST",
      headers: { "Api-Key": apiKey },
      credentials: "include"
    });

    const data = await res.json();

    if (data.success) {
      setMsg(`Printed ${data.printed} tickets`);
    } else {
      setMsg("Failed to print");
    }

    setLoading(false);
  }

  return (
    <section className="card">
      <h2>🖨 Print Ticket Queue</h2>
      <p className="muted small">Print all tickets that haven't been printed yet.</p>

      <button
        className="btn primary"
        disabled={loading}
        onClick={printAll}
      >
        {loading ? "Printing…" : "Print All Unprinted Tickets"}
      </button>

      {msg && <p className="muted small">{msg}</p>}
    </section>
  );
}